import React, { Component } from 'react';
import { withApollo, compose, graphql } from 'react-apollo';
import _ from 'lodash';
import debounce from 'lodash.debounce';

import { AllClaimStates } from '../../../../../queries/AllClaimStates';
import { ReattachClaimsPassengerTickets } from '../../../../../mutations/ReattachClaimsPassengerTickets';
import { isPassengerMoveable } from '../../../../../utils/passengersMoveableCrmStates';
import View from './View';

class AddPassenger extends Component {
  state = { selectedPassengers: [] };

  handleAddPassengerOpen = () => this.setState({ isAddPassengerVisible: true });
  handleAddPassengerClose = () =>
    this.setState({ isAddPassengerVisible: false });

  handleSavePassengers = () => {
    const { selectedPassengers } = this.state;

    if (!selectedPassengers || selectedPassengers.length === 0) return;
    const claimsPassengerTicketIds = selectedPassengers.map(
      passenger => passenger.id
    );
    const { client, showLoading, hideLoading, onClaimUpdated, id } = this.props;
    showLoading();
    client
      .mutate({
        mutation: ReattachClaimsPassengerTickets,
        variables: {
          input: {
            claimsPassengerTicketIds,
            targetClaimId: id
          }
        }
      })
      .then(() => {
        this.handleAddPassengerClose();
        onClaimUpdated();
        hideLoading();
      })
      .catch(() => {
        hideLoading();
      });
  };

  debounce = debounce(
    filterString => this.setState({ filter: filterString }),
    250
  );

  handleSearchPassengers = (e, { searchQuery }) => this.debounce(searchQuery);

  handlePassengerSelect = (e, { options, value }) => {
    const { selectedPassengers } = this.state;
    const {
      claimCrmState,
      data: { allClaimStates }
    } = this.props;
    const passengerData = options.find(
      passenger => passenger.id === value
    );
    const { crmState } = passengerData;
    const isAlreadySelected =
      selectedPassengers
        .map(passenger => passenger.id)
        .indexOf(value) !== -1;
    if (
      !isAlreadySelected &&
      isPassengerMoveable(claimCrmState, crmState, allClaimStates)
    ) {
      const newSelectedPassengers = selectedPassengers.concat(passengerData);
      this.setState({ selectedPassengers: newSelectedPassengers });
    }
  };

  handlePassengerDelete = passenger => {
    const { selectedPassengers } = this.state;
    const newSelectedPassengers = _.filter(
      selectedPassengers,
      selectedPassenger => selectedPassenger.value !== passenger.value
    );
    this.setState({ selectedPassengers: newSelectedPassengers });
  };

  render = () => {
    return (
      <View
        {...this.props}
        {...this.state}
        onPassengerDelete={this.handlePassengerDelete}
        onSavePassengers={this.handleSavePassengers}
        onAddPassengerOpen={this.handleAddPassengerOpen}
        onPassengerSelect={this.handlePassengerSelect}
      />
    );
  };
}

const AddPassengerContainer = compose(
  withApollo,
  graphql(AllClaimStates)
)(AddPassenger);

export default AddPassengerContainer;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Passengers/AddPassenger/index.js